@let certif = certificationAttachee();
<div class="gap-md grid">
  @if (certif) {
    <div>
      <p class="paragraph-medium-semibold text-content-primary">Certification rattachée</p>
      <app-card-certification [certification]="certif" [actions]="certificationActions" />
    </div>
    <div class="border-grey-2 border-t"></div>
  }
  <form [formGroup]="form()">
    <div class="flex flex-col gap-[12px]">
      <div class="flex">
        <span class="paragraph-medium-semibold text-content-primary flex-1">Aptitudes rattachées à l'étape</span>
        @if (form().enabled) {
          <button
            class="text-components-content-neutral-secondary"
            (click)="manualAddAptitudes()"
            hlmBtn
            variant="link"
            size="compact"
            type="button"
            text="medium"
          >
            Ajouter d'autres aptitudes
          </button>
        }
      </div>
      <div class="gap-md flex w-full flex-col">
        @for (aptitude of aptitudesCertif() | trierPar: 'nom'; track aptitude.id) {
          <app-detail-aptitude-item [aptitude]="aptitude" [form]="form()" [canCheck]="false" />
        }

        @for (aptitude of aptitudes.value | trierPar: 'nom'; track aptitude.id) {
          <app-detail-aptitude-item [aptitude]="aptitude" [form]="form()" [canCheck]="true" />
        }
      </div>
    </div>
  </form>
</div>
